import { createContext } from 'react'

import { type IInboxContext } from './types'

export const InboxContext = createContext<IInboxContext>(null)
